import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { PageLoadHook } from "../core/PageLoadHook.mjs";

export class ScrollableVideo extends PageLoadHook {
  constructor() {
    super();
    gsap.registerPlugin(ScrollTrigger);
  }

  get videos() {
    if (!this._videos) {
      this._videos = document.querySelectorAll(".inline-animation");
    }
    return this._videos;
  }

  get timelines() {
    if (!this._timelines) {
      this._timelines = [];
      for (const video of this.videos) {
        this._timelines.push(
          gsap.timeline({
            defaults: { duration: 1 },
            scrollTrigger: {
              trigger: video,
              scroller: ".right-column-wrapper",
              start: "top 55%",
              end: "clamp(+=256)",
              scrub: 1,
            },
          }),
        );
      }
    }
    return this._timelines;
  }

  onPageLoad() {
    this._oneshot(document.documentElement, "touchstart", () => {
      for (const video of this.videos) {
        video.play();
        video.pause();
      }
    });

    for (let videoIndex = 0; videoIndex < this.videos.length; ++videoIndex) {
      const video = this.videos[videoIndex];

      if (!video.duration) {
        this._oneshot(video, "loadedmetadata", () => {
          this.timelines[videoIndex].fromTo(
            video,
            {
              currentTime: 0,
            },
            {
              currentTime: video.duration || 1,
            },
          );
        });
      } else {
        this.timelines[videoIndex].fromTo(
          video,
          {
            currentTime: 0,
          },
          {
            currentTime: video.duration || 1,
          },
        );
      }
    }
  }

  _oneshot(element, event, callback) {
    const wrapperFunc = (eventInstance) => {
      element.removeEventListener(event, wrapperFunc);
      callback(eventInstance);
    };
    element.addEventListener(event, wrapperFunc);
  }
}
